import withSpacing from '../../decorators/withSpacing/index';
import RadioGroup from './RadioGroup';
export default withSpacing(RadioGroup);
//# sourceMappingURL=index.js.map